import {
  Drawer,
  Box,
  Typography,
  IconButton,
  Button,
  CircularProgress,
  Alert,
} from "@mui/material";
import React, { useContext } from 'react';

import CloseIcon from "@mui/icons-material/Close";
import { useState, useEffect } from "react";
import useAxiosRequests from "../../../hooks/useAxiosRequest";
import ExternalRoutes from "../../../config/ExternalRoutes";
import { useFormik } from "formik";
import * as Yup from "yup";
import { API_BASE_URL } from "../../../config/BaseUrl";
import pdfImage from "../../../img/pdf.png";
import { MessageContext } from "../../../context/MessageContext";


const DocumentUpdate = ({ open, handleClose, documentData, onUpdated }) => {
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [previewUrl, setPreviewUrl] = useState(null);
  const { sendRequest } = useAxiosRequests();
  const { showSuccess, showError } = useContext(MessageContext);

  console.log(documentData, 'documentData');
  const validationSchema = Yup.object({
    file: Yup.mixed()
      .nullable()
      .test("fileSize", "Fichier trop volumineux (max 5MB)", (value) => {
        if (!value) return true;
        return value.size <= 5 * 1024 * 1024;
      })
      .test("fileType", "Type de fichier invalide", (value) => {
        if (!value) return true;
        return ["image/jpeg", "image/png", "application/pdf"].includes(value.type);
      }),
  });


  const formik = useFormik({
    initialValues: {
      file: null,
    },
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      setErrorMessage("");
      setSuccessMessage("");

      const formData = new FormData();
      if (values.file) {
        formData.append("file", values.file);
      }

      try {
        const response = await sendRequest({
          method: "POST",
          url: `${ExternalRoutes.document.edit}${documentData?.row?.id}`,
          body: formData,
        });

        if (response.status === "error") {
          throw new Error(response.message || "Erreur lors de la modification.");
        }
        showSuccess("Image mise à jour avec succès.")
        onUpdated?.();
        setTimeout(() => setSuccessMessage(""), 3000);
        handleClose();
      } catch (err) {
        showError(err.message || "Une erreur est survenue lors de la modification.");

      } finally {
        setLoading(false);
      }
    },
  });

  const handleFileChange = (event) => {
    const file = event.currentTarget.files[0];
    if (file) {
      formik.setFieldValue("file", file);
      const preview = URL.createObjectURL(file);
      setPreviewUrl(file.type === "application/pdf" ? pdfImage : preview);
    }
  };

  useEffect(() => {
    let fileObj = documentData?.row?.docFile;
    let fileStr = documentData?.docFile;

    if (fileObj && typeof fileObj === "object") {
      const extension = fileObj.flExtension?.toLowerCase();
      if (extension === "pdf") {
        setPreviewUrl(pdfImage);
      } else if (fileObj.flUrl) {
        setPreviewUrl(`${API_BASE_URL}${fileObj.flUrl}`);
      } else {
        setPreviewUrl(null);
      }
    } else if (fileStr && typeof fileStr === "string") {
      if (/\.(pdf)$/i.test(fileStr)) {
        setPreviewUrl(pdfImage);
      } else {
        setPreviewUrl(`${API_BASE_URL}${fileStr}`);
      }
    } else {
      setPreviewUrl(null);
    }
  }, [documentData, open]);

  return (
    <Drawer open={open} onClose={handleClose} anchor="right">
      <Box p={3} width={500}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h6">Modifier le document</Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        {successMessage && <Alert severity="success">{successMessage}</Alert>}
        {errorMessage && <Alert severity="error">{errorMessage}</Alert>}

        <form onSubmit={formik.handleSubmit}>
          <Button variant="contained" component="label">
            Choisir un fichier
            <input type="file" hidden accept=".jpg,.jpeg,.png,.pdf" onChange={handleFileChange} />
          </Button>

          {previewUrl && (
            <Box mt={2}>
              <img
                src={previewUrl}
                alt="aperçu"
                style={{ maxWidth: "100%", height: "auto" }}
              />
            </Box>
          )}

          {(documentData?.row?.docFile?.flName ||
  (typeof documentData?.docFile === "string" && documentData.docFile)) && (
  <Typography variant="body2" mt={1}>
  </Typography>
)}

          {formik.errors.file && formik.touched.file && (
            <Typography color="error" variant="body2">
              {formik.errors.file}
            </Typography>
          )}

          <Box mt={3}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={loading}
              fullWidth
            >
              {loading ? <CircularProgress size={24} /> : "Enregistrer les modifications"}
            </Button>
          </Box>
        </form>
      </Box>
    </Drawer>
  );
};

export default DocumentUpdate;
